module.exports = __webpack_public_path__ + "media/images/favicons/acpaconnect-3e566ae44d3eb2987cb07e3b7725d350ad2606144773ee0f3cbf1e12773887af.ico";